export default __webpack_public_path__ + "79f4c6eaef30c176b41b2813482fd9f4.png";